import React from "react";
import WorkerGatePass  from "../workerGatepass/workerGate";
class VisitorPassParent extends React.Component {
    render() {
      return <WorkerGatePass type={"VGR"} title={"Visitor Gate Pass"} />;
    }
  }
  export default VisitorPassParent;